import { withStyles } from 'tss-react/mui';
import React, { useState } from 'react';
import { agentDeveloperUtils } from 'wobi-web-common';
const styles = (theme) => ({
	orangeLinkButton: {
		display: 'inline-block',
		marginTop: '0px',
		margin: '0px 10px',
		color: agentDeveloperUtils.getPrimaryColor(500), // Orange color
		background: 'none',
		border: 'none',
		cursor: 'pointer',
		fontWeight: 600,
		fontSize: '0.95rem',
		padding: 0,
		'&:hover': {
			textDecoration: 'none',
			color: agentDeveloperUtils.getPrimaryColor(150), // Slightly darker on hover
		},
	},
});
const CollapseExpand = ({ buttonText, closeText, children, classes }) => {
	const [isExpanded, setIsExpanded] = useState(false);
	const toggleVisibility = () => {
		setIsExpanded(!isExpanded);
	};

	const getButtonText = () => {
		if (isExpanded) {
			return closeText || buttonText;
		}
		return buttonText;
	};

	const handleKeyDown = (e) => {
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault();
			toggleVisibility();
		}
	};

	return (
		<>
			<div
				className={classes.orangeLinkButton}
				style={{
					color: isExpanded
						? agentDeveloperUtils.getSecondaryColor(200) // Slightly darker color when open
						: agentDeveloperUtils.getPrimaryColor(440), // Default orange color
				}}
				onClick={toggleVisibility}
				onKeyDown={handleKeyDown}
				role='button'
				tabIndex={0}
				aria-expanded={isExpanded}
				aria-label={buttonText}
			>
				{getButtonText()}
			</div>
			{isExpanded && <div>{children}</div>}
		</>
	);
};

export default withStyles(CollapseExpand, styles);
